import React, { useState } from 'react';
import { Form } from 'react-bootstrap';
import AuthService from '../services/AuthService';

export function useStatusEmailTestRouting() {
  const key = `graduation-status-email-test:${AuthService.getCurrentToken()?.starId || ''}`;
  const [enabled, setEnabled] = useState(() => {
    try { return sessionStorage.getItem(key) !== 'false'; } catch { return true; }
  });
  return [enabled, (value: boolean) => {
    setEnabled(value);
    try { sessionStorage.setItem(key, String(value)); } catch { /* Use the current page preference. */ }
  }] as const;
}

export default function StatusEmailTestControl({ enabled, onChange, disabled }: {
  enabled: boolean; onChange: (enabled: boolean) => void; disabled: boolean;
}) {
  return <div className="mb-3 no-print">
    <Form.Check type="switch" id="status-email-test" label="Send status-change and note emails to me for testing"
      checked={enabled} disabled={disabled} onChange={event => onChange(event.target.checked)} />
    <Form.Text className="d-block">{enabled
      ? 'Status-change and note emails from your saves go to your signed-in admin email, including advising notifications. Students will not receive them.'
      : 'Status-change and note emails use the normal delivery settings.'} This choice applies to undergraduate and graduate reviews in this browser tab. Queued emails keep the destination selected when saved.</Form.Text>
  </div>;
}
